import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Network } from "@ionic-native/network";
import { TranslateService } from "@ngx-translate/core";
import { Observable, TimeoutError } from "rxjs";
import {
  INVARIANT,
  SERVICES_API,
  ENVIRONMENT,
  THIRD_SERVICES_API,
} from "../../../config";
import { LoadingService } from "../loading/loading.service";
import { DialogService } from "../dialog/dialog.service";
import { GlobalState } from "../app/global/app.global";
import { EventService } from "../app/event/event.service";
import { LoggerService } from "../logger/logger.service";
import { RouterService } from "../router/router.services";
import { EncryptionSerProvider } from "../encryption";

@Injectable()
export class RequestService {
  private _COMMON: any;

  constructor(
    private http: HttpClient,
    private translateSer: TranslateService,
    private loadSer: LoadingService,
    private dialogSer: DialogService,
    private global: GlobalState,
    private network: Network,
    private logger: LoggerService,
    private routerSer: RouterService,
    private eventSer: EventService,
    private encySer: EncryptionSerProvider,
  ) {
    var _Z = setInterval(() => {
      this.translateSer.get("COMMON").subscribe((v) => {
        if (typeof v == "object") {
          this._COMMON = v;
          clearInterval(_Z);
        }
      });
    }, 150);
  }

  /**
   * 第三方指定接口地址调用
   * @param urlKey
   * @param params
   */
  public httpThirdRequest(urlKey, type, params): Observable<any> {
    return Observable.create((observer) => {
      let res = { code: "-", msg: "-", datas: [] };
      const api = THIRD_SERVICES_API[urlKey];
      if (!urlKey || !api) {
        res.code = "001";
        res.msg = this._COMMON.REQUEST_ERROR_NONEURL;
        this.requestError(urlKey, params, null, res.msg);
        return observer.error(res);
      }
      console.log("request-params----", params);
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json;charset=utf-8",
          JointBaseUrl: "false", //是否拼接服务地址
        }),
      };
      if (type == "post") {
        const body = params;
        this.http.post(api.url, body, httpOptions).subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          },
          (err) => {
            let error = this.requestError(api.url, params, null, err);
            observer.error(error);
          },
        );
      } else {
        httpOptions["params"] = params;
        this.http.get(api.url, httpOptions).subscribe(
          (response) => {
            console.log(response);
            observer.next(response);
            observer.complete();
          },
          (err) => {
            let error = this.requestError(api.url, params, null, err);
            observer.error(error);
          },
        );
      }
    });
  }

  /**
   * 登录用接口
   * @param urlKey
   * @param params
   */
  public httpRequestForLogin(
    urlKey,
    params,
    isLoading = true,
  ): Observable<any> {
    isLoading &&
      this.loadSer.showLoading(
        this._COMMON && this._COMMON.LOADING.LOADING_TEXT,
      );
    return Observable.create((observer) => {
      let res = { code: "-", msg: "-", datas: [] };
      const api = SERVICES_API[urlKey];
      if (!urlKey || !api) {
        res.code = "001";
        res.msg = this._COMMON.REQUEST_ERROR_NONEURL;
        this.requestError(urlKey, params, null, res.msg);
        isLoading && this.loadSer.hideLoading();
        return observer.error(res);
      }
      //isPointLogin：是否单点登录 ticket：单点登录验证信息
      const {
        username,
        password,
        deviceAppUUID,
        result,
        isPointLogin = 0,
        ticket = "",
        pageName,
        ...otherParams
      } = params;
      const accessToken = this.encySer.RSAEncry(
        username,
        password,
        deviceAppUUID,
        result,
      );
      const body =
        isPointLogin == "0"
          ? ""
          : {
              isPointLogin: isPointLogin,
              ticket: ticket,
              pageName: pageName,
              code: result,
              ...otherParams,
            };
      console.log("params----", params, "accessToken----", accessToken);
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          JointBaseUrl: "true", //是否拼接服务地址
          accessToken: accessToken, //加密验证
        }),
      };
      const { url, mockKey = "unknow_mockKey" } = api;
      if (ENVIRONMENT === "debug") {
        this.http
          .get(mockKey, httpOptions)
          .timeout(INVARIANT._REQUEST_TIMEOUT)
          .subscribe(
            (response) => {
              observer.next(response);
              isLoading && this.loadSer.hideLoading();
            },
            (err) => {
              let error = this.requestError(urlKey, params, null, err);
              isLoading && this.loadSer.hideLoading();
              observer.error(error);
            },
          );
      } else {
        this.http
          .post(url, body, httpOptions)
          .timeout(INVARIANT._REQUEST_TIMEOUT)
          .subscribe(
            (response) => {
              observer.next(response);
              isLoading && this.loadSer.hideLoading();
            },
            (err) => {
              let error = this.requestError(urlKey, params, null, err);
              isLoading && this.loadSer.hideLoading();
              observer.error(error);
            },
          );
      }
    });
  }

  /**
   * 统一http请求入口
   * @param urlKey 接口Key
   * @param params 参数
   * @param isLoading 是否显示加载loading
   */
  public httpRequest(
    urlKey: string,
    params: any = "",
    isLoading: boolean = true,
  ): Observable<any> {
    let res = { code: "-", msg: "-", datas: [] };
    const api = SERVICES_API[urlKey];
    if (!urlKey || !api) {
      res.code = "001";
      res.msg = this._COMMON.REQUEST_ERROR_NONEURL;
      this.requestError(urlKey, params, null, res.msg);
      return Observable.create((observer) => observer.error(res));
    }

    return Observable.create((observer) => {
      isLoading &&
        this.loadSer.showLoading(
          this._COMMON && this._COMMON.LOADING.LOADING_TEXT,
        );
      const handleSuccess = (response) => {
        this.logger.log("reponse--", response);
        isLoading && this.loadSer.hideLoading();
        this.responseError(urlKey, response)
          ? observer.next(response)
          : observer.error(response);
      };
      const handleError = (err) => {
        isLoading && this.loadSer.hideLoading();
        let error = this.requestError(urlKey, params, null, err);
        observer.error(error);
      };
      const { url, type, mockKey = "unknow_mockKey" } = api;
      if (ENVIRONMENT === "debug") {
        this.reqGet(mockKey, params).subscribe(
          (response) => {
            handleSuccess(response);
          },
          (err) => {
            handleError(err);
          },
        );
      } else {
        switch (type.toLowerCase()) {
          case "get":
            this.reqGet(url, params).subscribe(
              (response) => {
                handleSuccess(response);
              },
              (err) => {
                handleError(err);
              },
            );
            break;
          case "post":
            this.reqPost(url, params).subscribe(
              (response) => {
                handleSuccess(response);
              },
              (err) => {
                handleError(err);
              },
            );
            break;
          case "delete":
            this.reqDelete(url, params).subscribe(
              (response) => {
                handleSuccess(response);
              },
              (err) => {
                handleError(err);
              },
            );
            break;
          case "put":
            this.reqPut(url, params).subscribe(
              (response) => {
                handleSuccess(response);
              },
              (err) => {
                handleError(err);
              },
            );
            break;
          case "get":
            this.reqGet(url, params).subscribe(
              (response) => {
                handleSuccess(response);
              },
              (err) => {
                handleError(err);
              },
            );
            break;
          default:
            handleError("请检查接口配置或接口Key是否正确");
        }
      }
    });
  }

  private reqGet(url, params): Observable<any> {
    const httpOptions = {
      headers: this.getHeader(),
      params: params,
    };
    return this.http.get(url, httpOptions).timeout(INVARIANT._REQUEST_TIMEOUT);
  }
  private reqPost(url, params) {
    const httpOptions = {
      headers: this.getHeader(),
    };
    const body = params;
    return this.http
      .post(url, body, httpOptions)
      .timeout(INVARIANT._REQUEST_TIMEOUT);
  }
  private reqDelete(url, params) {
    const httpOptions = {
      headers: this.getHeader(),
      params: params,
    };
    return this.http
      .delete(url, httpOptions)
      .timeout(INVARIANT._REQUEST_TIMEOUT);
  }
  private reqPut(url, params) {
    const httpOptions = {
      headers: this.getHeader(),
    };
    const body = params;
    return this.http
      .put(url, body, httpOptions)
      .timeout(INVARIANT._REQUEST_TIMEOUT);
  }

  /**
   * 生成统一header 又该函数生成的hearder都会被加上token验证并拼接地址
   */
  private getHeader() {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      JointBaseUrl: "true", //是否拼接服务地址
      WithSecurityToken: "true", //是否使用token验证
    });
    const userinfo = this.global.state.userInfo || {};
    header.set(INVARIANT._REQUEST_USERID, userinfo.id + "");
    return header;
  }

  /**
   * 接口返回错误处理 与后端约定的错误处理code
   * @param urlKey 请求key
   * @param response 响应体
   */
  private responseError(urlKey, response): boolean {
    try {
      switch (response.code) {
        case "800": //token失效
          let alert = this.dialogSer.alert(this._COMMON.LOGIN_OUTTIME_RELOGIN);
          alert.onDidDismiss((e) => {
            this.eventSer.evExitLogin.emit(() => {
              this.routerSer.setRoot("login");
            });
          });
          alert.present();
          return false;
        default:
          return true;
      }
    } catch (error) {
      this.logger.log("urlKey", urlKey, "reponse-error---", error);
      return false;
    }
  }

  /**
   * 异常处理
   * @param url 请求地址
   * @param param 请求参数
   * @param header 请求头
   * @param error 错误返回信息
   * code：
   *      自定义：001--请求接口不存在  002--请求超时  003--无网络
   *      服务请求错误：0--服务请求连接失败  404--请求地址不存在  500--服务器错误
   * msg：错误信息
   */
  private requestError(url, param, header, error): Object {
    let res = { code: "-", msg: this._COMMON.ERROR_REQUST, datas: [] };
    this.logger.log(
      "%c 请求失败 %c",
      "color:red",
      "",
      "url:",
      url,
      "param:",
      param,
      "header:",
      header,
      "error:",
      error,
    );
    if (error instanceof TimeoutError) {
      res.code = "002";
      res.msg = this._COMMON.ERROR_NETWORK_TIMEOUT;
      this.dialogSer.alert(res.msg);
      return res;
    }
    if (this.network.type == "none") {
      res.code = "003";
      res.msg = this._COMMON.ERROR_NONE_NETWORK;
      this.dialogSer.alert(res.msg);
      return res;
    }
    res.msg = error.msg;
    res.code = error.code; //自定义错误
    let status = error.status; //http请求错误
    if (status === 0) {
      res.code = status;
      res.msg = this._COMMON.ERROR_REPONSE_ERR;
    } else if (status === 404) {
      res.code = status;
      res.msg = this._COMMON.ERROR_REQUST_ADDRESS;
    } else if (status === 500) {
      res.code = status;
      res.msg = this._COMMON.ERROR_REQUST_SERVICE;
    }

    this.dialogSer.alert(res.msg);
    return res;
  }

  public errorHandle(error) {
    //active --- noPage:页面不存在  noData:无数据  noInternet:无网络
    let result = "noData";
    try {
      switch (error.code) {
        case "001" || "404":
          result = "noPage";
          break;
        case "002" || "0" || "500":
          result = "noData";
          break;
        case "003":
          result = "noInternet";
          break;
      }
      return result;
    } catch (error) {
      console.log(error);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/common/http/request.service.ts